import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Button from 'fe-design-base/molecules/Button';
import List from 'fe-design-base/molecules/List';

import { getFeatureTitle } from 'features/productGrowth/utils';

import { toI18n } from 'util/i18n';

interface TierViewProps {
  focusedFeature?: string;
  tier: string;
}

const TierView = ({ focusedFeature, tier }: TierViewProps) => {
  const tierHighlights = toI18n(`manage_plans.plans.${tier}.highlights`);
  const planUrl = focusedFeature
    ? `/manage_plans?view=focus&plan=${tier}&origin=paywall&feature_key=${focusedFeature}`
    : `/manage_plans`;

  return (
    <Box borderbox column alignItemsStart justifyContentSpaceBetween p={30}>
      <Box>
        {/* Header */}
        <Box column gap={12} mb={48}>
          <Box>
            <Text
              variant="heading3"
              color="mono900"
              i18n="paywalls.modal.tier.title"
              i18nProps={{
                feature: getFeatureTitle(focusedFeature),
              }}
            />
          </Box>
          <Box>
            <Text
              color="mono700"
              i18n="paywalls.modal.tier.subtitle.available"
              inline
            />{' '}
            <Text capitalize inline color="mono700">
              {tier}
            </Text>{' '}
            <Text
              color="mono700"
              i18n="paywalls.modal.tier.subtitle.plan"
              inline
            />
            {tier !== 'all-in-one' && (
              <>
                {' '}
                <Text
                  color="mono700"
                  i18n="paywalls.modal.tier.subtitle.above"
                  inline
                />
              </>
            )}
            .
          </Box>
        </Box>

        {/* Tier Benefits */}
        <Box column gap={8}>
          <Box>
            <Text variant="heading4" color="mono900">
              <Text capitalize inline variant="heading4">
                {tier}
              </Text>{' '}
              {toI18n(`paywalls.modal.tier.tier_benefits`)}
            </Text>
          </Box>
          <Box>
            <List
              size="small"
              variant="check"
              gapOverride="8px"
              data={tierHighlights.map((highlights: string) => ({
                primary: highlights,
              }))}
            />
          </Box>
        </Box>
      </Box>

      {/* Action Buttons */}
      <Box w="100%" alignItemsCenter justifyContentEnd gap={8}>
        <Button
          variant="tertiary"
          href="/manage_plans"
          uxElement="explore_all_plans"
        >
          {toI18n(`paywalls.modal.tier.cta.explore_plans`)}
        </Button>
        <Button
          variant="primary"
          href={focusedFeature ? planUrl : '/manage_plans'}
          uxElement="view_plan_details"
        >
          {toI18n(`paywalls.modal.tier.cta.view_plan_details`)}
        </Button>
      </Box>
    </Box>
  );
};

export default TierView;
